import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { useQuery } from '@tanstack/react-query';
import UploadForm from './components/UploadForm/UploadForm';
import AttachmentTable from '../components/AttachmentTable/AttachmentTable';
import { fetchAttachments } from '../../../store/apis/expenseService';

import './UploadAttachmentsModal.scss';

function UploadAttachmentsModal({
  isOpen,
  toggle,
  claimNo,
  formType,
  claimStatus,
  finCoCd,
}) {
  const { data: attachments, isLoading: attachmentsIsLoading } = useQuery({
    queryKey: ['expense-claim-attachments', claimNo],
    queryFn: () =>
      fetchAttachments({
        docType: 'DOC_TYPE_EXPENSE_CLAIM',
        claimNo: claimNo || '',
        srNo: 0,
        finCoCd: finCoCd || '',
      }),
    enabled: !!claimNo,
  });

  return (
    <div>
      <Modal isOpen={isOpen} toggle={toggle} size="lg" centered>
        <ModalHeader toggle={toggle}>Upload Attachments</ModalHeader>
        <hr className="mb-1" />
        <ModalBody className="upload-attachments-modal">
          <UploadForm claimNo={claimNo} formType={formType} finCoCd={finCoCd} />
          <hr />
          <AttachmentTable
            claimNo={claimNo}
            attachments={attachments}
            queryKey="expense-claim-attachments"
            attachmentsIsLoading={attachmentsIsLoading}
            formType={formType}
            claimStatus={claimStatus}
            finCoCd={finCoCd}
          />
        </ModalBody>
      </Modal>
    </div>
  );
}

export default UploadAttachmentsModal;
